// src/pages/BlogsPage.js
import React, { useState, useCallback } from 'react';
import BlogForm from '../components/BlogForm';
import BlogList from '../components/BlogList';

const BlogsPage = () => {
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [alert, setAlert] = useState({ message: '', type: '' });
  const [refreshKey, setRefreshKey] = useState(0);

  const handleBlogAdded = (blog) => {
    console.log('Blog added:', blog);
    setSelectedBlog(null);
    refreshBlogs();
    handleAlert('Blog created successfully!', 'success');
  };

  const handleBlogUpdated = () => {
    setSelectedBlog(null);
    refreshBlogs();
    handleAlert('Blog updated successfully!', 'success');
  };

  const handleBlogDeleted = () => {
    setSelectedBlog(null);
    refreshBlogs();
    handleAlert('Blog deleted successfully!', 'success');
  };

  const handleEditBlog = (blog) => {
    setSelectedBlog(blog);
  };

  const handleAlert = (message, type) => {
    setAlert({ message, type });
    setTimeout(() => setAlert({ message: '', type: '' }), 3000);
  };

  const refreshBlogs = useCallback(() => {
    setRefreshKey((prevKey) => prevKey + 1);
  }, []);

  return (


    
    <div className="container mt-4">
      {/* <h1>Manage Blogs</h1> */}
      {alert.message && (
        <div className={`alert alert-${alert.type} mt-3`} role="alert">
          {alert.message}
        </div>
      )}
      <BlogForm
        blog={selectedBlog}
        onBlogAdded={handleBlogAdded}
        onBlogUpdated={handleBlogUpdated}
        onAlert={handleAlert}
      />
      <BlogList
        key={refreshKey}
        onBlogDeleted={handleBlogDeleted}
        onEditBlog={handleEditBlog}
      />
    </div>
  );
};

export default BlogsPage;
